import styled from "styled-components/macro";

export const ButtonContainer = styled.div`
  position: absolute;
  bottom: 31.8%;
  left: 24.5%;
  display: flex;
  justify-content: space-between;
  gap: 1em;
  bottom: 26%;
  left: 20%;
  width: 60%;

  display: grid;
  padding:0 1em;
  grid-template-columns: 1fr 1fr 1fr;
  

  & img {
    cursor: pointer;
    z-index: 10000;
  }

  & img:hover {
    background-color: #0069d9;
  }
  & img:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(24, 26, 28, 0.5);
  }
`;
export const YellowButton = styled.img`
`;

export const SmartKeyButton = styled.img``;

export const BlueButton = styled.img``;
